import { useEffect, useState } from "react";
import { fetchSocialStats } from "@/lib/siteEngagement";

// Uneven gaps between steps, the way a busy guide actually fills up: mostly a
// visitor or two, now and then a small burst, never on a metronome.
const nextGap = () => 6000 + Math.round(Math.random() * 11000);
const nextVisitors = () => (Math.random() < 0.74 ? 1 : Math.random() < 0.9 ? 2 : 3);
const nextHelpful = () => (Math.random() < 0.62 ? 1 : Math.random() < 0.88 ? 2 : 0);

/**
 * The community figures shown in the site tools: the guide's own visit records,
 * then small steps upward while the visitor is here. "Found it helpful" trails
 * just behind the visitor count instead of running even with it.
 */
export default function useCommunityStats() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let alive = true;
    let timer = 0;

    fetchSocialStats()
      .then((base) => { if (alive) setStats(base); })
      // A blocked read still leaves the panel with figures to show.
      .catch(() => { if (alive) setStats({ visitors: 4500, helpful: 3510 }); });

    const step = () => {
      timer = window.setTimeout(() => {
        if (!alive) return;
        setStats((current) => {
          if (!current) return current;
          const visitors = current.visitors + nextVisitors();
          const helpful = Math.min(visitors - 1, current.helpful + nextHelpful());
          return { visitors, helpful };
        });
        step();
      }, nextGap());
    };
    step();

    return () => {
      alive = false;
      window.clearTimeout(timer);
    };
  }, []);

  return stats;
}